import { TherapistAction } from 'src/redux/actions/constant';

const initialState: object = {
  response: null,
  loading: false,
  error: null,
  success: false,
};

export const scheduleAppointmentReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case TherapistAction.SCHEDULE_APPOINTMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case TherapistAction.SCHEDULE_APPOINTMENT_SUCCESS:
      return {
        ...state,
        response: action.payload,
        loading: false,
        error: null,
        success: true,
      };
    case TherapistAction.SCHEDULE_APPOINTMENT_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        error: action.payload,
        success: false,
      };
    case TherapistAction.SCHEDULE_APPOINTMENT_RESET:
      return initialState;
    default:
      return state;
  }
};

